"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const LRUCache_1 = require("../util/LRUCache");
class IPInfo {
}
exports.default = IPInfo;
IPInfo.ipInfoLruCache = new LRUCache_1.default();
IPInfo.getIPV4Info = (ip = undefined) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let result = undefined;
    try {
        if (ip) {
            const cachedResponse = IPInfo.ipInfoLruCache.get(ip);
            if (cachedResponse) {
                return cachedResponse;
            }
        }
        const res = yield fetch((_a = "https://freegeoip.app/json/" + ip) !== null && _a !== void 0 ? _a : "");
        const resJson = yield res.text();
        const parsedJson = JSON.parse(resJson);
        result = {
            ip: parsedJson.ip,
            latitude: parsedJson.latitude,
            longitude: parsedJson.longitude,
            country_code: parsedJson.country_code,
            country_name: parsedJson.country_name,
            city: parsedJson.city
        };
        if (ip) {
            IPInfo.ipInfoLruCache.put(ip, result);
        }
    }
    catch (e) {
        console.warn(`failed to get ip information for ip: ${ip} Error: ${JSON.stringify(e)}`);
        throw Error(`failed to get ip information for ip: ${ip} Error: ${JSON.stringify(e)}`);
    }
    return result;
});
//# sourceMappingURL=IPInfo.js.map